import { createRouter, createWebHistory } from 'vue-router';
import Search from '@/views/Search.vue';
import Settings from '@/views/Settings.vue';
import Pdf from '@/views/Pdf.vue';
import Home from '@/views/Home.vue';
import Language from '@/views/Language.vue';

const routes = [
  {
    path: '/',
    name: 'Language',
    component: Language,
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
  },
  {
    path: '/pdf/:id/:page?',
    // path: '/pdf',
    name: 'PDF',
    component: Pdf,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
